// API mode development 
//export const apiDomain = 'http://localhost:8081'

// API mode QA
//export const apiDomain = 'http://dev.drifttech.io:8181'

// API mode Production
export const apiDomain = 'https://app.drifttech.io/api'



// WEBPACK FOOTER //
// ./src/config.js